/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Pricing_PaidInputs */

const en_directory_pricing_paid = /** @type {(inputs: Directory_Pricing_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const zh_directory_pricing_paid = /** @type {(inputs: Directory_Pricing_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Directory_Pricing_PaidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_pricing_paid = /** @type {((inputs?: Directory_Pricing_PaidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Pricing_PaidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_pricing_paid(inputs)
	return zh_directory_pricing_paid(inputs)
});
export { directory_pricing_paid as "directory.pricing.paid" }